import { useTranslation } from 'react-i18next';
import { useMemo } from 'react';
import { MARKET } from '../constants/market';

interface BackUrlResponse {
  BACK_URL: string;
}

const useBackUrl = (): BackUrlResponse => {
  const { i18n } = useTranslation();
  const lang = i18n.language;
  const documentReferrer = typeof window !== 'undefined' ? document.referrer : '';

  const US_PROD_URL = 'https://www.audiusa.com/en/inventory/';
  const CA_PROD_URL = `https://www.audi.ca/${lang}/inventory/`;
  const isPrevFYMPage = documentReferrer.includes('find-your-match');

  const BACK_URL = useMemo(() => {
    if (isPrevFYMPage) return documentReferrer;
    const isCanadian = MARKET === 'ca' || MARKET === 'cauc';
    if (isCanadian) return CA_PROD_URL;
    return US_PROD_URL;
  }, [CA_PROD_URL, documentReferrer, isPrevFYMPage]);

  return { BACK_URL };
};

export default useBackUrl;
